import Company from '../models/Company'
import {action, makeObservable, observable} from 'mobx'
import {post} from '../common/requester'
import CompanyQuery from "../models/CompanyQuery";

class AdminStore {
  company = new Company()
  companies = []
  companies_query = new CompanyQuery()

  constructor() {
    makeObservable(this, {
      company: observable,
      companies: observable,
      companies_query: observable,
      resetCompany: action,
      setCompany: action,
      setCompanies: action,
      saveCompany: action,
      searchCompanies: action,
      getCompany: action,
    })
  }
  resetCompany() {
    this.company = new Company()
  }

  setCompany(company) {
    this.company.fromJson(company)
  }
  setCompanies(companies) {
    this.companies = companies
  }
  async saveCompany() {
    if (this.company.is_valid) {
      const response = await post('adm/save_company', this.company)
      this.setCompany(response.company)
      return Promise.resolve(response)
    } else {
      return Promise.reject('Баарын толтур')
    }
  }
  async searchCompanies() {
    const response = await post('adm/companies', this.companies_query).catch((err) => console.error('--companies error',err))
    if (response  && response.result === 0) {
      this.setCompanies(response.items)
      this.companies_query.setProperty('count', response.count)
      this.companies_query.setProperty('page_number', response.page_number)
      this.companies_query.setProperty('page_count', response.page_count)
    }
    return Promise.resolve(response)
  }

  async getCompany(id) {
    const response = await post('adm/get_company', {id}).catch((err) => console.error('--get_company error',err))
    if (response  && response.result === 0) {
      this.setCompany(response.company)
    }
    return Promise.resolve(response)
  }
}

const adminStore = new AdminStore();
export default adminStore;